// extracted by mini-css-extract-plugin
module.exports = {"barcode":"ProductForm_barcode__2E-AP","container":"ProductForm_container__1zDn9","actions":"ProductForm_actions__naSLg","uploader":"ProductForm_uploader__1aUx0"};